import { loadableWithFallback } from '@vision/ui/utils';
import type { PieChart1Props } from './PieChart1';

export const PieChart1 = loadableWithFallback<PieChart1Props>(() => import('./PieChart1'));
